import {GET_VIDEO} from './actionTypes'


const initialVideoState = {
  videoLink: '',
  fulfilledVideo: false,
}

export const GetVideoReducer = (state = initialVideoState, action) => {
  switch (action.type) {
    case GET_VIDEO:
      return {
        ...state,
        videoLink: action.payload,
        fulfilledVideo: true,
      }

    default:
      return state
  }
};

export default GetVideoReducer
